'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useDebounce = function (data, interval) {
    var _a = React__default['default'].useState(data), liveData = _a[0], setLiveData = _a[1];
    React__default['default'].useEffect(function () {
        if (typeof window !== "undefined") {
            var handler_1 = window.setTimeout(function () {
                setLiveData(data);
            }, interval);
            return function () {
                window.clearTimeout(handler_1);
            };
        }
    }, [data, interval]);
    return liveData;
};

var Autosave = function (_a) {
    var data = _a.data, onSave = _a.onSave, _b = _a.interval, interval = _b === void 0 ? 2000 : _b, _c = _a.element, element = _c === void 0 ? React__default['default'].createElement(React__default['default'].Fragment, null) : _c;
    var initialRender = React__default['default'].useRef(true);
    var debouncedValueToSave = useDebounce(data, interval);
    React__default['default'].useEffect(function () {
        if (initialRender.current) {
            initialRender.current = false;
        }
        else {
            if (debouncedValueToSave) {
                onSave(debouncedValueToSave);
            }
        }
    }, [debouncedValueToSave, interval, onSave]);
    return element;
};

var useAutosave = function (_a) {
    var data = _a.data, onSave = _a.onSave, _b = _a.interval, interval = _b === void 0 ? 2000 : _b;
    var initialRender = React__default['default'].useRef(true);
    var debouncedValueToSave = useDebounce(data, interval);
    React__default['default'].useEffect(function () {
        if (initialRender.current) {
            initialRender.current = false;
        }
        else {
            if (debouncedValueToSave) {
                onSave(debouncedValueToSave);
            }
        }
    }, [debouncedValueToSave, interval, onSave]);
};

exports.Autosave = Autosave;
exports.useAutosave = useAutosave;
exports.useDebounce = useDebounce;
